import { useSelector, useDispatch } from "react-redux"
import { useState, useEffect } from "react"
import Cookies from "universal-cookie";
import md5 from 'js-md5'
import { useParams } from "react-router-dom";
import Container from "../components-layout/Container" // Container toda app
import Layout from "../Layout" // Layout toda app
import WarningModal from "../components-modals/WarningModal" // Modal mensajes para el usuario

//import PageHeading from "./AdmisionesHeading" // Header Admisiones
import Header from "../components-layout/Header"
import { AcademicCapIcon } from '@heroicons/react/24/outline'
import StepAdmin from "./AdmisionesStep" // Header pasos Admisiones
import StepSidebarAdmin from "./AdmisionesStepSidebar" // Sidebar pasos Admisiones
import AdminStep1 from "./AdmisionesStep1" // Paso 1 Admisiones
import AdminStep2 from "./AdmisionesStep2" // Paso 2 Admisiones
import AdminStep3 from "./AdmisionesStep3" // Grid cuotas admisiones sale en paso 2
import AdminPago from "./AdmisionesPago" // Pago evaluación diagnostica
import { fetchApi } from "./helpers" // Consumir api
import { getAuth } from '../../app/authSlice'
import { useFetcher } from "react-router-dom";

// complete
// current
// upcoming

// Header pasos
const steps = [
    { id: '01', name: 'SELECCIÓN DE CAMPUS', href: '#', status: 'current' },
    { id: '02', name: 'INGRESO DE DATOS', href: '#', status: 'upcoming' },
    { id: '03', name: 'FINALIZA LA PRIMERA ETAPA', href: '#', status: 'upcoming' },
]

// Sidebar pasos
const stepsSidebar = [
    { name: 'Selección de campus', description: 'Seleccionar el campus y grado que vas a cursar.', href: '#', status: 'current' },
    { name: 'Ingreso de datos', description: 'Ingresa los datos solicitados para tú admisión 2025', href: '#', status: 'upcoming' },
    { name: 'Finaliza la primera etapa', description: 'Visualiza las cuotas promocionales y paga tú evaluación diagnóstica', href: '#', status: 'upcoming' },
]

const AdmisionesIndex = () => {

    const [isShowing, setIsShowing] = useState(false) // para mostrar tarjeta ins y col
    const [estadoAlumno, setEstadoAlumno] = useState("");
    const [esNuevo, setEsNuevo] = useState(false)
    const [datosGradoParametro, setDatosGradoParametro] = useState({})
    const { idSolicitud, fechaNacimiento } = useParams();
    const [parametros, setParametros] = useState({
        idSolicitud: idSolicitud,
        fechaNacimiento: fechaNacimiento
    })
    //Seleccionado: false
    const dispatch = useDispatch()
    const [contador, setContador] = useState(false)
    const validarUser = useSelector(state => state.auth.user)

    const urlAdmin = process.env.REACT_APP_URL_API_SEG // Para pruebas
    // const urlAdmin = process.env.REACT_APP_URL_API_PRO_SEG // Para producción 
    //console.log('AdmisionesIndex', validarUser)
    localStorage.removeItem('showAdmisiones')
    // useEffect(() => {
    //     console.log('useEffect', validarUser)
    if ((validarUser === null || validarUser === undefined || validarUser === '' || validarUser === false) && !contador) {
        localStorage.setItem('showAdmisiones', JSON.stringify(true))
        setContador(true)
        //console.log(contador, 'contador')
        dispatch(getAuth({
            config: {
                method: "POST", //Propiedad method, "POST", "GET", etc
                url: urlAdmin + "/seguridad/login", //URL de la API
                headers: {
                    'Authorization': process.env.REACT_APP_TOKEN_API,
                    'Content-ID': process.env.REACT_APP_AUDIENCIA_API,
                    'Content-Type': 'application/json'
                }, //Propiedad headers, por si la API solicita token, audiencia, etc
                payload: JSON.stringify({ LoginId: 'publico', password: 'c@mpu$V4' }), //Propiedad payload --> datos a enviar en la solicitud http
            },
            rememberUser: false,
        }))
    }
    // }, [])

    const [datosInscripcion, setDatosInscripcion] = useState({})
    const [datosInscripcionStep1, setDatosInscripcionStep1] = useState({})

    const obtenerCarnet = (carnet) => {
        setDatosInscripcion({
            ...datosInscripcion,
            CarnetValidado: carnet,
        })
    }
    /*
        const setSeleccionado = (paramSeleccionado) => {
            setDatosInscripcion({
                ...datosInscripcion,
                Seleccionado: paramSeleccionado
            })
        }
    */
    const user = useSelector(state => state.auth.user)
    //console.log('user', user)
    const userObj = JSON.parse(user)
    const cookies = new Cookies()
    //const [url] = useState( cookies.get('__urlSchoolApi') )
    const url = cookies.get('__urlSchoolApi') // url para enviar al api viene de cookies
    const url2 = cookies.get('__urlInvoiceApi') // url para enviar al api viene de cookies
    const { headersAPI: headers } = useSelector(state => state.url) // Headers para enviar al api viene de redux
    const IdEmp = useSelector(state => state.auth.IdEmp); // IdEmp usuario logueado viene de redux
    const sede = useSelector (state => state.auth.IdSede);

    const [pasos, setPasos] = useState(steps);
    const [pasosSidebar, setPasosSidebar] = useState(stepsSidebar);
    const [datosPasos, setDatosPasos] = useState({ form: 1 });
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false)
    const [propiedades, setPropiedades] = useState({})
    const [idSeleccionado, setIdSeleccionado] = useState('')
    const [haySolicitudSeleccionada, setHaySolicitudSeleccionada] = useState(false)
    const [planesVentana, setPlanesVentana] = useState({})
    const [seleccionado, setSeleccionado] = useState(false)

    const [sidebarVisible, setSidebarVisible] = useState(true)
    const handleSeleccionado = (parametro) => {
        setSeleccionado(parametro)
    }
    const [datosFormNuevo, setDatosFormNuevo] = useState({
        "hayData": false,
        "Apellidos": '',
        "Nombres": '',
        "ApellidosE": '',
        "NombresE": '',
        "ColAnterior": '',
        "Cel": '',
        "FechaNace": '',
        "Genero": '',
    })


    

    const handleDatosFormNuevo = (apellidos, nombres, apellidose, nombrese, colanterior, cel, genero, fechanace, set) => {
        
        setDatosFormNuevo({
            ...datosFormNuevo,
            "hayData": set,
            "Apellidos": apellidos,
            "Nombres": nombres,
            "ApellidosE": apellidose,
            "NombresE": nombrese,
            "ColAnterior": colanterior,
            "Cel": cel,
            "FechaNace": fechanace,
            "Genero": genero,
            //"EmailE": emaile
        });

    }
    
    const sendPlanes = (estado) => {
        setPlanesVentana(estado)
        setDatosGradoParametro(planesVentana)
    }

    const [idsRuta, setIdsRuta] = useState({})

    const handleIdSeleccionado = (seleccionado) => {
        setHaySolicitudSeleccionada(seleccionado)
    }
    const [rutaAlt, setRutaAlt] =  useState('./img/loader.gif')


    const enviarCorreo = async (props) => {
        
        setLoading(true)
        let res = await fetchApi({
          method: "POST",
          url: url + '/inscripciones/enviaremailaspirantes',
          headers: headers,
          content: {
            "IdSolicitud": props.IdSoli,
            "Email": props.Email ,
            "IdEmp": IdEmp
          }
        });
        setLoading(false)
        
    }

    const validForm = async (props = []) => {
        //

        //
        if (props.IdSoli !== undefined) {
            setIdSeleccionado(props.Idsoli)
        }

        let arrPasos = []
        let arr = []
        let arrSidebar = []
        let status1 = ''
        let status2 = ''
        let status3 = ''

        // Se activa el form 3 (Grid de cuotas)
        if (props.form === 3) {
            setLoading(true);
            const res = await fetchApi({
                url: url + '/inscripciones/cuotaspromo',
                headers,
                content: {
                    IdSolicitud: props.IdSoli
                }
            })
            setData(res)
            //console.log(193, res)
            setLoading(false); 
            setPropiedades(props)
            //setSolicitudSeleccionada(true)
        }
        // Fin activación form 3
        // Se activa el form 4 (Pago evaluación diagnóstica)
        if (props.form === 4) {
            //console.log('props: ', props)
            enviarCorreo(props)
            //  directorio: ../../img/loader.gif
            if(idsRuta.IdSede){
                setRutaAlt('../../img/loader.gif')
            }
            setLoading(true);

            const resPago = await fetchApi({
                url: url + '/inscripciones/paganuevos',
                headers,
                content: {
                    IdSolicitud: props.IdSoli,
                    IdEmp,
                    HostName: "DEV1",
                    IpHost: "131.107.1.235",
                    NombreBrowser: "Windows"
                }
            })
            const res = await fetchApi({
                url: url + '/utils/busquedas',
                headers,
                content: {
                    opcion: 'VAL_EXA_NUEVOS',
                    Idsede: props.IdSede || idsRuta.IdSede,
                    idgrado: props.IdGrado || idsRuta.IdGrado
                }
            })
            
            setData(res)

            setLoading(false);
            //setSolicitudSeleccionada(true)
        }
        // Fin activación form 4

        arrPasos = { ...props }


        status1 = ((props.valido === 0 && props.paso === 1) ? 'current' : (props.valido === 1 && props.paso === 1) ? 'complete' : (props.paso > 1) ? 'complete' : 'upcoming')
        status2 = ((props.valido === 1 && props.paso === 1) ? 'current' : (props.valido === 1 && props.paso === 2) ? 'complete' : (props.paso > 2) ? 'complete' : 'upcoming')
        status3 = ((props.valido === 1 && props.paso === 2) ? 'current' : (props.valido === 1 && props.paso === 3) ? 'complete' : 'upcoming')

        pasos?.map((obj) => {
            switch (Object.values(obj)[0]) {
                case '01':
                    arr.push({ id: Object.values(obj)[0], name: Object.values(obj)[1], href: Object.values(obj)[2], status: status1 })
                    break
                case '02':
                    arr.push({ id: Object.values(obj)[0], name: Object.values(obj)[1], href: Object.values(obj)[2], status: status2 })
                    break
                case '03':
                    arr.push({ id: Object.values(obj)[0], name: Object.values(obj)[1], href: Object.values(obj)[2], status: status3 })
                    break
                default:
                    arr.push({ id: Object.values(obj)[0], name: Object.values(obj)[1], href: Object.values(obj)[2], status: 'current' })
                    break
            }
            return arr
        })

        pasosSidebar?.map((obj) => {
            switch (Object.values(obj)[0]) {
                case 'Selección de campus':
                    arrSidebar.push({ name: Object.values(obj)[0], description: Object.values(obj)[1], href: Object.values(obj)[2], status: status1 })
                    break
                case 'Ingreso de datos':
                    arrSidebar.push({ name: Object.values(obj)[0], description: Object.values(obj)[1], href: Object.values(obj)[2], status: status2 })
                    break
                case 'Finaliza la primeta etapa':
                    arrSidebar.push({ name: Object.values(obj)[0], description: Object.values(obj)[1], href: Object.values(obj)[2], status: status3 })
                    break
                default:
                    arrSidebar.push({ name: Object.values(obj)[0], description: Object.values(obj)[1], href: Object.values(obj)[2], status: 'current' })
                    break
            }
            return arrSidebar
        })
        setPasos(arr)
        setPasosSidebar(arrSidebar)
        setDatosPasos(arrPasos)
    }

    useEffect(() => {
        setIsShowing(false)
        if(parametros.idSolicitud){
            //console.log(isShowing)
            setDatosPasos({ form: 2 })
            setPasos(
                [
                    { id: '01', name: 'SELECCIÓN DE CAMPUS', href: '#', status: 'complete' },
                    { id: '02', name: 'INGRESO DE DATOS', href: '#', status: 'complete' },
                    { id: '03', name: 'FINALIZA LA PRIMERA ETAPA', href: '#', status: 'current' },
                ]
            )
            // Sidebar pasos
            setPasosSidebar(
                [
                   { name: 'Selección de campus', description: 'Seleccionar el campus y grado que vas a cursar.', href: '#', status: 'complete' },
                   { name: 'Ingreso de datos', description: 'Ingresa los datos solicitados para tú admisión 2025', href: '#', status: 'complete' },
                   { name: 'Finaliza la primera etapa', description: 'Visualiza las cuotas promocionales y paga tú evaluación diagnóstica', href: '#', status: 'current' },
               ]
            )
        }else{
            setDatosPasos(()=>({ form: 1 }))
        }
    }, [parametros.idSolicitud])

    function setearSiEsCualquierPaso(nombre, id, valor, codigo) {
        setDatosInscripcion({
            ...datosInscripcion,
            [nombre]: valor,
            [codigo]: id,
        })
    }

    function setearSiEsPaso1(nombre, id, valor, codigo) {
        setDatosInscripcionStep1({
            ...datosInscripcionStep1,
            [nombre]: valor,
            [codigo]: id,
        })
    }
    function obtenerDatosInscripcion(nombre, valor, id, form) {
        switch (nombre) {

            case 'IdSede':
                (form === 1 ? setearSiEsPaso1(nombre, valor, id, 'Sede') : setearSiEsCualquierPaso(nombre, valor, id, 'Sede'))
                break;

            case 'IdGrado':
                (form === 1 ? setearSiEsPaso1(nombre, valor, id, 'Grado') : setearSiEsCualquierPaso(nombre, valor, id, 'Grado'))
                break;

            case 'IdCarrera':
                (form === 1 ? setearSiEsPaso1(nombre, valor, id, 'Carrera') : setearSiEsCualquierPaso(nombre, valor, id, 'Carrera'))
                break;

            case 'IdPlan':
                (form === 1 ? setearSiEsPaso1(nombre, valor, id, 'Plan') : setearSiEsCualquierPaso(nombre, valor, id, 'Plan'))
                break;

            default:
                break;
        }
    }

    useEffect(() => {

        let width = window.screen.width
        let height = window.screen.height

        if (width > height) {
            setSidebarVisible(true)
        } else {
            setSidebarVisible(false)
        }



        
    
        function handlePress(event) {
          if (document.activeElement.name === "Dpi" || document.activeElement.name === "E_DPI") {
              if (!`${event.target.value}${event.key}`.match(/^[0-9]*$/)) {
                  event.preventDefault();
                  event.stopPropagation();
                  return false;
              }
          }
        }
        
        window.addEventListener("keypress", handlePress);
        return () => {    
            
            window.removeEventListener("keypress", handlePress);
        }

    }, [])


    return (
        <Layout userObj={userObj} activeTab='Aspirantes'>
            <Container height='h-full'>
                <Header
                    title="Proceso de admisión 2025"
                    logo={AcademicCapIcon}
                />

                {
                    (datosPasos.form === 1) ?
                        (<>
                            <StepAdmin pasos={pasos} />
                            {sidebarVisible ?
                                <StepSidebarAdmin pasosSidebar={pasosSidebar} />
                                : null}
                            <AdminStep1
                                Validar={validForm}
                                parametros={parametros}
                                valido={datosPasos.valido}
                                IdSede={datosPasos.IdSede}
                                IdPlan={datosPasos.IdPlan}
                                IdCarrera={datosPasos.IdCarrera}
                                IdGrado={datosPasos.IdGrado}
                                url={url}
                                headers={headers}
                                Email={datosPasos.Email}
                                Dpi={datosPasos.Dpi}
                                Nombres={datosPasos.Nombres}
                                Apellidos={datosPasos.Apellidos}
                                FechaNace={datosPasos.FechaNace}
                                ColAnterior={datosPasos.ColAnterior}
                                Genero={datosPasos.Genero}
                                NombresE={datosPasos.NombresE}
                                ApellidosE={datosPasos.ApellidosE}
                                EmailE={datosPasos.EmailE}
                                Cel={datosPasos.Cel}
                                obtenerDatosInscripcion={obtenerDatosInscripcion}
                                handleIdSeleccionado={handleIdSeleccionado}
                                haySolicitudSeleccionada={haySolicitudSeleccionada}
                                handleDatosFormNuevo={handleDatosFormNuevo}
                                isShowing={isShowing}
                                setIsShowing={setIsShowing}
                                sede={sede}
                                IdEmp={IdEmp}
                            />
                        </>)
                        : (datosPasos.form === 2) ?
                            (<>
                                <StepAdmin pasos={pasos} />
                                {sidebarVisible ?
                                    <StepSidebarAdmin pasosSidebar={pasosSidebar} />
                                    : null}

                                <AdminStep2
                                    Validar={validForm}
                                    valido={datosPasos.valido}
                                    IdSede={datosPasos.IdSede}
                                    IdPlan={datosPasos.IdPlan}
                                    IdCarrera={datosPasos.IdCarrera}
                                    IdGrado={datosPasos.IdGrado}
                                    url={url}
                                    url2={url2}
                                    headers={headers}
                                    IdEmp={IdEmp}
                                    Email={datosPasos.Email}
                                    Dpi={datosPasos.Dpi}
                                    Nombres={datosPasos.Nombres}
                                    Apellidos={datosPasos.Apellidos}
                                    FechaNace={datosPasos.FechaNace}
                                    ColAnterior={datosPasos.ColAnterior}
                                    Genero={datosPasos.Genero}
                                    NombresE={datosPasos.NombresE}
                                    ApellidosE={datosPasos.ApellidosE}
                                    EmailE={datosPasos.EmailE}
                                    Cel={datosPasos.Cel}
                                    datosPasos={datosPasos}
                                    obtenerCarnetEstudiante={obtenerCarnet}
                                    idSeleccionado={idSeleccionado}
                                    handleIdSeleccionado={handleIdSeleccionado}
                                    haySolicitudSeleccionada={haySolicitudSeleccionada}
                                    handleDatosFormNuevo={handleDatosFormNuevo}
                                    datosFormNuevo={datosFormNuevo}
                                    obtenerCarnet={obtenerCarnet}
                                    datosInscripcion={datosInscripcion}
                                    setDatosInscripcion={setDatosInscripcion}
                                    obtenerDatosInscripcion={obtenerDatosInscripcion}
                                    sendPlanes={sendPlanes}
                                    handleSeleccionado={handleSeleccionado}
                                    datosInscripcionStep1={datosInscripcionStep1}
                                    parametros={parametros}
                                    setDatosPasos={setDatosPasos}
                                    setIdsRuta={setIdsRuta}
                                    setRutaAlt={setRutaAlt}
                                    idsRuta={idsRuta}
                                    rutaAlt={rutaAlt}
                                    setDatosGradoParametro={setDatosGradoParametro}
                                    setPasosSidebar={setPasosSidebar}
                                    setEsNuevo={setEsNuevo}
                                    esNuevo={esNuevo}
                                    setEstadoAlumno={setEstadoAlumno}
                                />
                            </>)
                            : (datosPasos.form === 3) ? (
                                <>
                                    <WarningModal
                                        open={loading ? true : false}
                                        image={<img src={rutaAlt} alt='loading' />}
                                        opacity='bg-opacity-100'
                                    />
                                    <StepAdmin pasos={pasos} />
                                    {sidebarVisible ?
                                        <StepSidebarAdmin pasosSidebar={pasosSidebar} />
                                        : null}
                                    <div className="grid grid-cols-6 gap-6">
                                        <div className="px-2 py-2 col-span-full lg:col-start-1 lg:col-end-6 rounded-lg bg-secundarioMira">
                                            < AdminStep3
                                                cuotas={data}
                                                Validar={validForm}
                                                url={url}
                                                headers={headers}
                                                IdSoli={datosPasos.IdSoli}
                                                IdSede={datosPasos.IdSede}
                                                IdPlan={datosPasos.IdPlan}
                                                IdCarrera={datosPasos.IdCarrera}
                                                IdGrado={datosPasos.IdGrado}
                                                Email={datosPasos.Email}
                                                Dpi={datosPasos.Dpi}
                                                Nombres={datosPasos.Nombres}
                                                Apellidos={datosPasos.Apellidos}
                                                FechaNace={datosPasos.FechaNace}
                                                ColAnterior={datosPasos.ColAnterior}
                                                Genero={datosPasos.Genero}
                                                NombresE={datosPasos.NombresE}
                                                ApellidosE={datosPasos.ApellidosE}
                                                EmailE={datosPasos.EmailE}
                                                Cel={datosPasos.Cel}
                                                handleIdSeleccionado={handleIdSeleccionado}
                                                haySolicitudSeleccionada={haySolicitudSeleccionada}
                                                handleDatosFormNuevo={handleDatosFormNuevo}
                                                datosFormNuevo={datosFormNuevo}
                                                datosInscripcion={datosInscripcion}
                                                obtenerDatosInscripcion={obtenerDatosInscripcion}
                                                planesVentana={planesVentana}
                                                seleccionado={seleccionado}
                                                datosInscripcionStep1={datosInscripcionStep1}
                                                rutaAlt={rutaAlt}
                                                datosGradoParametro={datosGradoParametro}
                                                estadoAlumno={estadoAlumno}
                                            />
                                        </div>
                                    </div>
                                </>)
                                : (<>
                                    <WarningModal
                                        open={loading ? true : false}
                                        image={<img src={rutaAlt} alt='loading' />}
                                        opacity='bg-opacity-100'
                                    />
                                    <StepAdmin pasos={pasos} />
                                    <StepSidebarAdmin pasosSidebar={pasosSidebar} />
                                    < AdminPago
                                        IdEmp={IdEmp}
                                        data={data}
                                        url={url}
                                        headers={headers}
                                        CarnetEstudiante={datosInscripcion.CarnetValidado}
                                        Validar={validForm}
                                        propiedades={propiedades}
                                        handleIdSeleccionado={handleIdSeleccionado}
                                        haySolicitudSeleccionada={haySolicitudSeleccionada}
                                        datosInscripcion={datosInscripcion}
                                        planesVentana={planesVentana}
                                        seleccionado={seleccionado}
                                        datosInscripcionStep1={datosInscripcionStep1}
                                        datosGradoParametro={datosGradoParametro}
                                        rutaAlt={rutaAlt}
                                    />
                                </>)
                }
            </Container>
        </Layout >
    )
}

export default AdmisionesIndex